import { IParam, isDate, isNumber, isObject, isUndefinedOrNull, param, RegionId } from "../../omnia"
import { INtrBalance } from "../../types"

export function getRequirementDetails(req: any, balance: INtrBalance): { key: string, value: any }[] {

    var keys = Object.keys(req).sort();

    let results = keys.map(k => {

        var value = req[k];
        if ((!isDate(value)) && isObject(value)) return null;

        value = formatValue(k, value);
        if (isUndefinedOrNull(value) || (value == "")) return null;

        return {
            key: k,
            value: value
        }

    }).filter(i => !!i);

    if (balance) {

        let b = balance;

        let balanceDetails = [
            { key: "BalanceN", value: b.CalcN },
            { key: "BalanceP2O5", value: b.CalcP2O5 },
            { key: "BalanceP2O5SoilIndex", value: b.P2O5SoilIndex },
            { key: "BalanceK2O", value: b.CalcK2O },
            { key: "BalanceK2OSoilIndex", value: b.K2OSoilIndex },
            { key: "BalanceMgO", value: b.CalcMgO }
        ].filter(i => !isUndefinedOrNull(i.value));

        results = results.concat(balanceDetails);

    }

    return results;

}

var formatters: { [key: string]: (value: any) => string };

function getEnumFormatter(enumLabels: () => IParam[]): ((value: any) => string) {

    const e = enumLabels()

    return (value: any) => {

        if (!e) {
            return value;
        }

        var t = e.find(i => i.value == value);

        if (t) {
            return t.text + " (" + t.value + ")";
        }

        if (!value) {
            return "";
        }

        return value;

    }
}

function formatPercent(value: any): string {

    if (isNumber(value)) {
        return (value * 100) + "%";
    }

    return value;

}

function setup() {

    var grassMgmt = getEnumFormatter(() => param.GrassManagementEngland().concat(param.GrassManagementScotland()))
    var grassCuts = getEnumFormatter(param.GrassCuts)

    formatters = {
        Region: getEnumFormatter(param.RegionId),
        GrassManagement: grassMgmt,
        GrassCuts: grassCuts,
        PrevGrassManagement: grassMgmt,
        PrevGrassCuts: grassCuts,
        SnsMethod: getEnumFormatter(param.NitrogenSnsMethod),
        NFertiliserEfficiency: formatPercent,
        CovercropBiomass: getEnumFormatter(param.BiomassLevel),
        LimingFactorType: getEnumFormatter(param.LimingFactor),
        CropMarket: getEnumFormatter(param.CropPurpose),
        SoilCategory: getEnumFormatter(param.SoilCategory),
        SoilTypeId: getEnumFormatter(param.SoilTypeId),
        SubsoilTypeId: getEnumFormatter(param.SubsoilTypeId),
    }

}

function formatValue(key: string, value: any): string {

    if (!formatters) {
        setup();
    }

    var fmt = formatters[key];
    if (fmt) value = fmt(value);

    if (isDate(value)) {
        var date = <Date>value;
        value = date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    return value;

}
